module.exports = __webpack_public_path__ + "img/art_6_2.7eb7547e.png";